import React, { useState } from "react";
import Menu from "../../components/Menu";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../apiFormData";
import Swal from "sweetalert2";

import "./Partners.css";
import Clear from "../../assets/img/remove.svg";
import InputImage from "../../components/InputImage";
import InputCPFCNPJ from "../../components/InputCPFCNPJ";
import InputPhone from "../../components/InputPhone";
import InputPhoneMobile from "../../components/InputPhoneMobile";
import InputDate from "../../components/InputDate";
import Validations from "../../Validations";
import LoadingBlock from "../../components/LoadingBlock";
import ModalYesNo from "../../components/ModalYesNo";
import Avatar from "../../assets/img/hospital.svg";
import FooterEdit from "../../components/FooterEdit";
import useProceduresPartners from "./hooks/useProceduresPartners";
import ProcedimentosModal from "../../components/modals/ProcedimentosModal";
import ProceduresModal from "../../components/modals/ProceduresModal";

import ListaProcedimentosAssociados from "../../components/ListaProcedimentosAssociados.js";

import Globals from "../../Globals";
import { Link } from "react-router-dom";
import ProfessionalsModal from "../../components/modals/ProfessionalsModal.js";

function PartnersEdit() {
  let { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [partnerId, setPartnerId] = useState(14);
  const [error, setError] = useState({});
  const [teleconsultation, setTeleconsultation] = useState(null);
  const [accessApp, setAccessApp] = useState(null);
  const [name, setName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [location, setLocation] = useState("");
  const [urlAccess, setUrlAccess] = useState("");
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [phone, setPhone] = useState("");
  const [status, setStatus] = useState("");
  const [phoneMobile, setPhoneMobile] = useState("");

  const [contract, setContract] = useState("");
  const [contractDate, setContractDate] = useState("");
  const [contractExpiration, setContractExpiration] = useState("");
  const [packageClient, setPackageClient] = useState("");

  const [shoppers, setShoppers] = useState([]);
  const [relatedShoppers, setRelatedShoppers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenProf, setIsModalOpenProf] = useState(false);
  const [isModalOpenProc, setIsModalOpenProc] = useState(false);
  const [selectedShopper, setSelectedShopper] = useState(null);
  const [sectors, setSectors] = useState([]);
  const [enabledProcedures, setEnabledProcedures] = useState([]);
  const [disabledProcedures, setDisabledProcedures] = useState([]);
  const [queryProc, setQueryProc] = useState(""); // Estado para o campo de busca
  const [selectedSector, setSelectedSector] = useState(); // Estado para o setor selecionado
  const [searchProcs, setSearchProcs] = useState([]); // Estado para os procedimentos exibidos

  //dados de proficional de exemplo
  const dadosProfessionals = [
    { id: 1, name: "Dr. João Silva", especialidade: "Cardiologista" },
    { id: 2, name: "Dr. Maria Oliveira", especialidade: "Ginecologista" },
    { id: 3, name: "Dr. Paulo Roberto", especialidade: "Ortopedista" },
    { id: 4, name: "Dr. Ana Paula", especialidade: "Dermatologista" },
    { id: 5, name: "Dr. Pedro Henrique", especialidade: "Oftalmologista" },
    { id: 1, name: "Dr. João Silva", especialidade: "Cardiologista" },
    { id: 2, name: "Dr. Maria Oliveira", especialidade: "Ginecologista" },
    { id: 3, name: "Dr. Paulo Roberto", especialidade: "Ortopedista" },
    { id: 4, name: "Dr. Ana Paula", especialidade: "Dermatologista" },
    { id: 5, name: "Dr. Pedro Henrique", especialidade: "Oftalmologista" },
    { id: 1, name: "Dr. João Silva", especialidade: "Cardiologista" },
    { id: 2, name: "Dr. Maria Oliveira", especialidade: "Ginecologista" },
    { id: 3, name: "Dr. Paulo Roberto", especialidade: "Ortopedista" },
    { id: 4, name: "Dr. Ana Paula", especialidade: "Dermatologista" },
    { id: 5, name: "Dr. Pedro Henrique", especialidade: "Oftalmologista" },
  ];
  const dadosProcedures = [
    { id: 1, name: "Dr. João Silva", especialidade: "Cardiologista" },
    { id: 2, name: "Dr. Maria Oliveira", especialidade: "Ginecologista" },
    { id: 3, name: "Dr. Paulo Roberto", especialidade: "Ortopedista" },
    { id: 4, name: "Dr. Ana Paula", especialidade: "Dermatologista" },
    { id: 5, name: "Dr. Pedro Henrique", especialidade: "Oftalmologista" },
    { id: 1, name: "Dr. João Silva", especialidade: "Cardiologista" },
    { id: 2, name: "Dr. Maria Oliveira", especialidade: "Ginecologista" },
    { id: 3, name: "Dr. Paulo Roberto", especialidade: "Ortopedista" },
    { id: 4, name: "Dr. Ana Paula", especialidade: "Dermatologista" },
    { id: 5, name: "Dr. Pedro Henrique", especialidade: "Oftalmologista" },
  ];

  // Função para mudar de setor
  const changeSector = (event) => {
    const selected = sectors.find(
      (sector) => sector.id === parseInt(event.target.value, 10)
    );
    setSelectedSector(selected);
  };

  // Simula busca de procedimentos com base no `queryProc`
  const filterProcedures = (query) => {
    if (!query) {
      // Retorna todos os procedimentos caso não haja busca
      return [
        { id: 1, name: "Procedimento A" },
        { id: 2, name: "Procedimento B" },
      ];
    }
    return [
      { id: 1, name: "Procedimento A" },
      { id: 2, name: "Procedimento B" },
    ].filter((proc) => proc.name.toLowerCase().includes(query.toLowerCase()));
  };

  // Atualiza a lista de procedimentos ao digitar na barra de busca
  const handleQueryChange = (e) => {
    const query = e.target.value;
    setQueryProc(query);
    setSearchProcs(filterProcedures(query));
  };

  const excluirParceiro = async () => {
    try {
      const response = await api.delete(`/api/affiliatecompany/delete/${id}`); // Substitua pelo endpoint correto

      // Exibe uma notificação de sucesso
      Swal.fire({
        title: "Parceiro excluído com sucesso!",
        icon: "success",
        confirmButtonText: "OK",
      }).then((result) => {
        if (result.isConfirmed) {
          // Redireciona para a página de parceiros
          navigate("/partners");
        }
      });
    } catch (error) {
      alert("Erro ao excluir o parceiro. Tente novamente.");
    }
  };

  const [image, setImage] = useState({
    fileReal: "",
    file: "",
  });

  const handleSaveAll = () => {
    //console.log('entrou');
  };

  const handleScroll = (event) => {
    const threshold = 1;

    // Obtenha as dimensões reais do elemento scrollado
    const scrollContainerRect = event.target.getBoundingClientRect();
    const scrollContentRect = event.target.scrollHeight;

    // Obtenha a altura visível do contêiner de rolagem
    const clientHeight = scrollContainerRect.height;

    // Obtenha a distância do topo da área de rolagem até o topo da viewport
    const scrollTop = event.target.scrollTop;

    // Calcule a diferença entre a altura total e a altura já rolada
    const scrollBottom = scrollTop + clientHeight;

    // Ajuste a lógica para verificar quando o scroll atinge o final
    if (scrollBottom + threshold >= scrollContentRect) {
      this.getSectorProcedures();
    }
  };
  const openModal = () => setIsModalOpen(true);
  const openModalProf = () => setIsModalOpenProf(true);
  const openModalProc = () => setIsModalOpenProc(true);

  const closeModal = () => {
    setSelectedShopper(null);
    setIsModalOpen(false);
  };

  const closeModalProf = () => {
    setSelectedShopper(null);
    setIsModalOpenProf(false);
  };

  const closeModalProc = () => {
    setSelectedShopper(null);
    setIsModalOpenProc(false);
  };

  const onDelete = () => {
    setShowModal(false);
    setLoading(true);
    api
      .delete("/api/partners/" + id)
      .then((response) => {
        Swal.fire({
          title: "Cliente excluído com sucesso",
          icon: "success",
          confirmButtonColor: "#3c8dbc",
        });
        setTimeout(() => {
          Swal.close();
          setTimeout(() => {
            navigate("/partners");
          }, 750);
        }, 1500);
      })
      .catch((error) => {
        console.error(error);
        Swal.fire({
          title: "Parceiro não excluído",
          text: error.message,
          icon: "error",
          confirmButtonColor: "#3c8dbc",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleShopperClick = (shopperId) => {
    navigate(`/shoppers/${shopperId}`);
  };

  const onSubmit = (ev) => {
    ev.preventDefault();
    var cpfCnpjClear = cpfCnpj
      .replaceAll("/", "")
      .replaceAll(".", "")
      .replaceAll("-", "");
    console.log(cpfCnpjClear);
    var errors = {
      name: name.replaceAll(" ", "") === "" ? true : false,
      companyName: companyName.replaceAll(" ", "") === "" ? true : false,
      address: address.replaceAll(" ", "") === "" ? true : false,
      email: !Validations.emailValid(email),
      cpfCnpj: !(cpfCnpjClear.length < 12
        ? Validations.CPFValid(cpfCnpj)
        : Validations.CNPJValid(cpfCnpj)),
      phone: !Validations.PhoneValid(phone),
      mobile: !Validations.PhoneMobile(phoneMobile),
      status: status === "" ? true : false,
      contractDate: Validations.DateDDMMAAAAInvalid(contractDate),
      contractExpiration: Validations.DateDDMMAAAAInvalid(contractExpiration),
      contract: contract === "" ? true : false,
      accessUrl: urlAccess === "" ? true : false,
      teleconsultation: teleconsultation === null ? true : false,
      accessApp: accessApp === null ? true : false,
    };
    setError(errors);
    var validations = true;

    for (const key in errors) {
      if (errors.hasOwnProperty(key) && errors[key] === true) {
        validations = false;
      }
    }

    if (validations) {
      var form = new FormData();

      image.fileReal !== ""
        ? form.set("image", image.fileReal)
        : console.log("");
      form.set("id", id);
      form.set("name", name);
      form.set("company_name", companyName);
      form.set("email", email);
      form.set("type", cpfCnpjClear.length < 12 ? 0 : 1);
      form.set("cnpj_cpf", cpfCnpjClear);
      form.set("address_info", address);
      form.set("contract_number", contract);
      form.set(
        "phone",
        phone
          .replaceAll(" ", "")
          .replaceAll("(", "")
          .replaceAll(")", "")
          .replaceAll("-", "")
      );
      form.set(
        "mobile",
        phoneMobile
          .replaceAll(" ", "")
          .replaceAll("(", "")
          .replaceAll(")", "")
          .replaceAll("-", "")
      );
      form.set(
        "contract_date",
        contractDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3$2$1")
      );
      form.set(
        "contract_valid",
        contractExpiration.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3$2$1")
      );
      form.set("status", parseInt(status, 10));
      form.set("access_url", urlAccess);
      form.set("location", location);
      form.set("package_id", packageClient);
      form.set("access_app", accessApp);

      form.set("video_appointment", teleconsultation);

      setLoading(true);
      api
        .post("/api/affiliatecompanies", form)
        .then((response) => {
          Swal.fire({
            title: "Registro atualizado com sucesso",
            icon: "success",
            confirmButtonColor: "#3c8dbc",
          });
        })
        .catch((error) => {
          console.error(error);
          Swal.fire({
            title: "Registro não atualizado",
            text: error.message,
            icon: "error",
            confirmButtonColor: "#3c8dbc",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const screenTela = (
    <>
      {loading && <LoadingBlock />}
      <ModalYesNo
        show={showModal}
        setShow={setShowModal}
        affirnName={"Deletar"}
        negName={"Voltar"}
        afirmativeFunc={onDelete}
        message={"Ao excluir um registro não será possivel recuperar"}
        title={"Tem certeza?"}
        imgSVG={Clear}
      />
      <form onSubmit={onSubmit}>
        <div className="screenContainer edit-mode">
          <div className="my-header-partner">
            <h1>Empresa</h1>
            <label>ACHEMED</label>
          </div>
          <div className="row">
            <h4>Dados Básicos</h4>
            <div className="d-flex justify-content-center col-12 col-sm-4 col-lg-4">
              <InputImage
                imageAvatar={Avatar}
                image={image}
                setImage={setImage}
              />
            </div>
            <div
              className="col-12 col-sm-4 col-lg-4 row"
              style={{ padding: "0px", margin: "-1px" }}>
              <div className="col-12">
                <label className="form-label-input">Nome*</label>
                <input
                  className="form-control"
                  value={name}
                  type="text"
                  name="name"
                  placeholder="Nome"
                  onChange={(value) =>
                    setName(value.target.value.toUpperCase())
                  }
                />
                {error.name && <span className="error">Campo Inválido</span>}
              </div>
              <div className="col-12">
                <label className="form-label-input">Email*</label>
                <input
                  className="form-control"
                  value={email}
                  onChange={(value) => setEmail(value.target.value)}
                  type="text"
                  name="email"
                  placeholder="Email"
                />
                {error.email && <span className="error">Campo Inválido</span>}
              </div>
              <div className="col-12">
                <label className="form-label-input">CPF/CNPJ*</label>
                <InputCPFCNPJ value={cpfCnpj} onChange={setCpfCnpj} />
                {error.cpfCnpj && <span className="error">Campo Inválido</span>}
              </div>
            </div>
            <div
              className="col-12 col-sm-4 col-lg-4 row"
              style={{ padding: "0px", margin: "-1px" }}>
              <div className="col-12">
                <label className="form-label-input">Nome da Empresa*</label>
                <input
                  className="form-control"
                  value={companyName}
                  type="text"
                  name=""
                  placeholder="Nome da Empresa"
                  onChange={(value) =>
                    setCompanyName(value.target.value.toUpperCase())
                  }
                />
                {error.companyName && (
                  <span className="error">Campo Inválido</span>
                )}
              </div>
              <div className="col-12">
                <label className="form-label-input">Endereço*</label>
                <input
                  className="form-control"
                  value={address}
                  onChange={(value) =>
                    setAddress(value.target.value.toUpperCase())
                  }
                  type="text"
                  name="address_info"
                  placeholder="Endereço"
                />
                {error.address && <span className="error">Campo Inválido</span>}
              </div>
            </div>
          </div>
          <div className="row row-mod-hei">
            <div className="col-12 col-sm-4">
              <label className="form-label-input">Telefone*</label>
              <InputPhone value={phone} onChange={setPhone} />
              {error.phone && <span className="error">Campo Inválido</span>}
            </div>
            <div className="col-12 col-sm-4">
              <label className="form-label-input">Celular*</label>
              <InputPhoneMobile value={phoneMobile} onChange={setPhoneMobile} />
              {error.mobile && <span className="error">Campo Inválido</span>}
            </div>
            <div className="col-12 col-sm-4">
              <label className="form-label-input">URL de Acesso*</label>
              <input
                className="form-control"
                value={urlAccess}
                onChange={(value) => setUrlAccess(value.target.value)}
                type="text"
                name="access_url"
                placeholder="URl de Acesso"
              />
              {error.accessUrl && <span className="error">Campo Inválido</span>}
            </div>
          </div>
          <div className="row row-mod-hei">
            <div className="col-12 col-sm-4">
              <label className="form-label-input">Localização</label>
              <input
                className="form-control"
                value={location}
                onChange={(value) => setLocation(value.target.value)}
                type="text"
                name="location"
                placeholder="Localização"
              />
            </div>

            <div className="col-12 col-sm-4" style={{ paddingTop: 6 }}>
              <label className="form-label-input">Telemedicina*</label>
              <div>
                <div className="form-check form-check-inline">
                  <input
                    onChange={() => {
                      setTeleconsultation(true);
                    }}
                    className="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio2"
                    checked={teleconsultation}
                    value={
                      teleconsultation === null && teleconsultation !== false
                        ? false
                        : teleconsultation
                    }
                  />
                  <label className="form-check-label" htmlFor="inlineRadio2">
                    Ativa
                  </label>
                </div>

                <div className="form-check form-check-inline">
                  <input
                    onChange={() => {
                      setTeleconsultation(false);
                    }}
                    className="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio1"
                    checked={!teleconsultation}
                    value={
                      teleconsultation === null && teleconsultation !== true
                        ? false
                        : true
                    }
                  />
                  <label className="form-check-label" htmlFor="inlineRadio1">
                    Desativada
                  </label>
                </div>
              </div>

              {error.teleconsultation && (
                <span className="error">Campo Inválido</span>
              )}
            </div>

            <div style={{ paddingTop: 6 }} className="col-12 col-sm-4">
              <label className="form-label-input">App*</label>
              <div>
                <div className="form-check form-check-inline">
                  <input
                    onChange={() => {
                      setAccessApp(true);
                    }}
                    className="form-check-input"
                    type="radio"
                    name="inlineRadioOptionsApp"
                    id="inlineRadioApp2"
                    checked={accessApp}
                    value={
                      accessApp === null && accessApp !== false
                        ? false
                        : accessApp
                    }
                  />
                  <label className="form-check-label" htmlFor="inlineRadioApp2">
                    Ativa
                  </label>
                </div>

                <div className="form-check form-check-inline">
                  <input
                    onChange={() => {
                      setAccessApp(false);
                    }}
                    className="form-check-input"
                    type="radio"
                    name="inlineRadioOptionsApp"
                    id="inlineRadioApp1"
                    checked={!accessApp}
                    value={
                      accessApp === null && accessApp !== true ? false : true
                    }
                  />
                  <label className="form-check-label" htmlFor="inlineRadioApp1">
                    Desativada
                  </label>
                </div>
              </div>

              {error.accessApp && <span className="error">Campo Inválido</span>}
            </div>
          </div>

          <div className="row row-mod-hei">
            <h4 style={{ marginTop: "20px" }}>Dados de Contrato</h4>
            <div className="col-12 col-sm-4">
              <label className="form-label-input">Contrato*</label>
              <input
                className="form-control"
                value={contract}
                onChange={(value) => {
                  var inputValue = value.target.value.replace(/[a-zA-Z]/g, "");
                  setContract(inputValue);
                }}
                type="text"
                name="contract_number"
                placeholder="Contrato"
              />
              {error.contract && <span className="error">Campo Inválido</span>}
            </div>
            <div className="col-12 col-sm-4">
              <label className="form-label-input">Data do Contrato*</label>
              <InputDate value={contractDate} onChange={setContractDate} />
              {error.contractDate && (
                <span className="error">Campo Inválido</span>
              )}
            </div>
            <div className="col-12 col-sm-4">
              <label className="form-label-input">
                Vencimento do Contrato*
              </label>
              <InputDate
                value={contractExpiration}
                onChange={setContractExpiration}
              />
              {error.contractExpiration && (
                <span className="error">Campo Inválido</span>
              )}
            </div>
          </div>
          <div>
            <div className="my-body-procedimentos">
              <div className="my-lista-procediementos-associados">
                {/*Abrir o modal quando o botão for clicado */}
                <button
                  type="button"
                  onClick={openModal}
                  className="my-modal-button">
                  Ver Procedimento
                </button>
                <ProcedimentosModal
                  isModalOpen={isModalOpen}
                  closeModal={closeModal}
                  id={id}
                />
                <button
                  type="button"
                  onClick={openModalProf}
                  className="my-modal-button-prof">
                  Ver Profissionais
                </button>
                <ProfessionalsModal
                  isOpen={isModalOpenProf}
                  onClose={closeModalProf}
                  items={dadosProfessionals}
                />
                {/* <button type="button" onClick={openModalProc} className="my-modal-button-proc">Ver Procedimentos</button> 
              <ProceduresModal isOpen={isModalOpenProc} onClose={closeModalProc} items={dadosProcedures} /> */}
              </div>
            </div>
          </div>
        </div>

        <FooterEdit
          navigateRoute={"/partners"}
          onClickDel={() => {
            const confirmar = window.confirm(
              "Tem certeza de que deseja excluir este parceiro? Esta ação não pode ser desfeita."
            );
            if (confirmar) {
              excluirParceiro();
            }
          }}
        />
      </form>
    </>
  );

  <></>;

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const responseDetails = await api.get(
          `/api/affiliatecompany/show/details/${id}`
        );
        const data = responseDetails.data.affiliate_company;

        setShoppers(data.shoppers || []);
        setStatus(data.status);
        setImage({
          fileReal: "",
          file: data.image,
        });
        setPackageClient(data.package_id === null ? "" : data.package_id);
        setUrlAccess(data.access_url);
        setAddress(data.address_info);
        setName(data.name);
        setCompanyName(data.company_name);
        setEmail(data.email);
        setLocation(data.location);
        setContract(data.contract_number);

        console.log(data.contract_number);
        setContractDate(
          data.contract_date.split("-").reverse().join("-").replaceAll("-", "/")
        );
        console.log(data.contract_date);
        setContractExpiration(
          data.contract_valid
            .split("-")
            .reverse()
            .join("-")
            .replaceAll("-", "/")
        );
        setCpfCnpj(
          data.cnpj_cpf.length === 11
            ? data.cnpj_cpf.replace(
                /^(\d{3})(\d{3})(\d{3})(\d{2})/,
                "$1.$2.$3-$4"
              )
            : data.cnpj_cpf.replace(
                /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                "$1.$2.$3/$4-$5"
              )
        );
        setPhone(data.phone.replace(/^(\d{2})(\d{4})(\d{4})/, "($1) $2 - $3"));
        setPhoneMobile(
          data.mobile.replace(
            /^(\d{2})(\d{1})(\d{4})(\d{4})/,
            "($1) $2 $3 - $4"
          )
        );
        setTeleconsultation(data.video_appointment);
        setAccessApp(data.access_app);
      } catch (error) {
        setShoppers([]);
      }
    };

    fetchData();
  }, [id]);

  return <Menu screen={screenTela} />;
}

export default PartnersEdit;

/* const openModal = async (shopper) => {
    // buscar procedimentos e setores
    const responseSectors = await api.get("/api/sectors/list");
    setSectors(responseSectors.data.sectors);

    const obj = {
      company_id: id,
      shopper_id: shopper.id,
    }
    const responseProcedures = await api.post("/api/affiliatecompany/list/shopper/procedures/relations", obj);
    setEnabledProcedures(responseProcedures.data.procedures_enabled);
    setDisabledProcedures(responseProcedures.data.procedures_disabled);

    setSelectedShopper(shopper);
    if (sectors) {
      setSelectedSector(sectors[0]);
    }
    setIsModalOpen(true);
  };
   */
